import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger, type TooltipContentProps } from '@shared/components/ui';

export interface GenericTooltipProps extends Omit<TooltipContentProps, 'children' | 'content'> {
  children: ReactNode;
  content: ReactNode;
}

export const GenericTooltip = ({ children, content, ...tooltipContentProps }: GenericTooltipProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent {...tooltipContentProps}>{content}</TooltipContent>
    </Tooltip>
  );
};
